'use client'

import { cx } from 'utils/cx'

import { ListBody } from '../../ListItemBody'
import type { LinkListItemProps } from '../LinkListItemProps'

import styles from '../../ListItem.module.scss'

export function LinkListClientItem<T>(props: LinkListItemProps<T>) {
	const {
		id,
		title,
		titleUpperCase = false,
		linkAs: LinkComponent = 'a',
		icon,
		linkAttributes,
		selected,
		'data-testid': dataTestId,
		subtitle,
		onClick = () => {},
		'aria-current': ariaCurrent = 'page',
		showArrow = true,
	} = props

	return (
		<li id={id} data-testid={dataTestId}>
			<LinkComponent
				className={cx(styles.listItem, selected && styles.selected)}
				onClick={
					selected ? (e: React.MouseEvent) => e.preventDefault() : onClick
				}
				aria-current={selected && ariaCurrent}
				aria-disabled={selected}
				{...(linkAttributes as T)}
			>
				<ListBody
					titleUpperCase={titleUpperCase}
					title={title}
					icon={icon}
					subtitle={subtitle}
					showArrow={showArrow}
				/>
			</LinkComponent>
		</li>
	)
}
